const methodAuth = {
    businessAuth: [
        {
            name: 'Smart OTP',
            name_EN: 'Smart OTP',
            value: 'TOKEN_OTP'
        },
        {
            name: 'Chữ ký số',
            name_EN: "Digital signature",
            value: 'PKI_OTP'
        },
        {
            name: 'Chữ ký số và Smart OTP',
            name_EN: "Smart OTP and Digital signature",
            value: 'PKI_OTP;TOKEN_OTP'
        }
    ],
    approve: [
        {
            name: 'Smart OTP',
            name_EN: 'Smart OTP',
            value: 'TOKEN_OTP'
        },
        {
            name: 'Duyệt nhanh',
            name_EN: 'Quick approval',
            value: 'PKI_OTP'
        }
    ],
    checker: [
        {
            name: 'Smart OTP',
            name_EN: 'Smart OTP',
            value: 'TOKEN_OTP'
        },
        {
            name: 'Duyệt nhanh',
            name_EN: 'Quick approval',
            value: 'PKI_OTP'
        }
    ],
    maker: [
        {
            name: 'Smart OTP',
            name_EN: 'Smart OTP',
            value: 'TOKEN_OTP'
        },
        {
            name: 'Chữ ký số',
            name_EN: "Digital signature",
            value: 'PKI_OTP'
        },
        {
            name: 'Kết hợp cả Smart OTP và chữ ký số',
            name_EN: "Combination of Smart OTP and Digital signature",
            value: 'PKI_OTP;TOKEN_OTP'
        }
    ],
};
const TransLevel = [
    {
        value: 2,
        name: '2 cấp',
        name_EN: '2 levels'
    },
    {
        value: 3,
        name: '3 cấp',
        name_EN: '3 levels'
    }       
];
const USER_ROLE = {
    VIEWER: "VIEWER",
    MAKER: "MAKER",
    CHECKER: "CHECKER",
    APPROVER: "APPROVER"
};
const AUTHEN_TYPE = {
    PKI_OTP: "PKI_OTP", // chữ ký số for maker, Duyệt nhanh for approver and checker
    TOKEN_OTP: "TOKEN_OTP" // Smart OTP
};
const ROLE = [
    {
        name: "Truy vấn",
        value: "VIEWER",
        name_EN: "Viewer"
    },
    {
        name: "Nhập lệnh",
        value: "MAKER",
        name_EN: "Maker"
    },
    {
        name: "Kiểm soát",
        value: "CHECKER",
        name_EN: "Checker"
    },
    {
        name: "Người duyệt",
        value: "APPROVER",
        name_EN: "Approver"
    },
    {
        name: "Truy vấn tài khoản định danh",
        value: "VIEWER_ALIAS",
        name_EN: "Alias viewer"
    }
]
export {methodAuth, TransLevel, USER_ROLE, AUTHEN_TYPE, ROLE}